
interface ThisProps {
//  uidAuftrag: string;
}

/**
 * @author noone
 */
const HinweisMessverfahrenDownloadButtonComponent: React.FC<ThisProps> = ({  }) => {

   const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/Hinweise ASG 260407.pdf"; // Pfad zur PDF im public-Ordner
    link.download = "Hinweise ASG 260407.pdf";     // gewünschter Dateiname
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <button className="btn btn-secondary" onClick={handleDownload}>
            <i className="bi bi-download"></i> Hinweise zu Auftragserteilung und Messverfahren
          </button>
    </>
  );

}

export default HinweisMessverfahrenDownloadButtonComponent;